import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  LOGIN_SAP_BUSCAR_LOGIN_SAP_BEGIN,
  LOGIN_SAP_BUSCAR_LOGIN_SAP_SUCCESS,
  LOGIN_SAP_BUSCAR_LOGIN_SAP_FAILURE,
  LOGIN_SAP_BUSCAR_LOGIN_SAP_DISMISS_ERROR,
} from './constants';
import initialState from './initialState';
import * as Services from '../../../sdk/services';

export function buscarLoginSap(filter = {}) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: LOGIN_SAP_BUSCAR_LOGIN_SAP_BEGIN,
    filter,
  };
}

export function dismissBuscarLoginSapError() {
  return {
    type: LOGIN_SAP_BUSCAR_LOGIN_SAP_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on LOGIN_SAP_BUSCAR_LOGIN_SAP_BEGIN actions
export function* doBuscarLoginSap(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    const LoginSAPApi = new Services['LoginSAPApi']();
    res = yield LoginSAPApi.buscarLoginSap(action.filter);
  } catch (err) {
    yield put({
      type: LOGIN_SAP_BUSCAR_LOGIN_SAP_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: LOGIN_SAP_BUSCAR_LOGIN_SAP_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchBuscarLoginSap() {
  yield takeLatest(LOGIN_SAP_BUSCAR_LOGIN_SAP_BEGIN, doBuscarLoginSap);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_SAP_BUSCAR_LOGIN_SAP_BEGIN:
      return {
        ...state,
        registroLoginSap: initialState.registroLoginSap,
        buscarLoginSapPending: true,
        buscarLoginSapError: null,
      };

    case LOGIN_SAP_BUSCAR_LOGIN_SAP_SUCCESS:
      return {
        ...state,
        registroLoginSap: action.data,
        buscarLoginSapPending: false,
        buscarLoginSapError: null,
      };

    case LOGIN_SAP_BUSCAR_LOGIN_SAP_FAILURE:
      return {
        ...state,
        buscarLoginSapPending: false,
        buscarLoginSapError: action.data.error,
      };

    case LOGIN_SAP_BUSCAR_LOGIN_SAP_DISMISS_ERROR:
      return {
        ...state,
        buscarLoginSapError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login-sap/redux/buscarLoginSap.js